'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002463 from "./presto.-Credentials-View$$anon$63.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002464 from "./presto.-Credentials-View$$anon$64.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002465 from "./presto.-Credentials-View$$anon$65.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002466 from "./presto.-Credentials-View$$anon$66.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002467 from "./presto.-Credentials-View$$anon$67.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$62(outer) {
  this.aHL = null;
  this.aHJ = null;
  this.aHK = false;
  this.aHH = null;
  this.aHI = false;
  this.aHM = false;
  this.aHN = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aHL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$62 as $c_Lpresto_CredentialsView$$anon$62 };
$p = $c_Lpresto_CredentialsView$$anon$62.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$62;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$62() {
}
export { $h_Lpresto_CredentialsView$$anon$62 as $h_Lpresto_CredentialsView$$anon$62 };
$h_Lpresto_CredentialsView$$anon$62.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aHL;
});
$p.t = (function() {
  if ((!this.aHK)) {
    this.aHJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySeed", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByTfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySiteAndGroup", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByDocument", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aHK = true;
  }
  return this.aHJ;
});
$p.ag = (function() {
  if ((!this.aHI)) {
    this.aHH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002463.$c_Lpresto_CredentialsView$$anon$63(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002464.$c_Lpresto_CredentialsView$$anon$64(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002465.$c_Lpresto_CredentialsView$$anon$65(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002466.$c_Lpresto_CredentialsView$$anon$66(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aHI = true;
  }
  return this.aHH;
});
$p.v = (function() {
  if ((!this.aHN)) {
    this.aHM = true;
    this.aHN = true;
  }
  return this.aHM;
});
$p.ad6 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002467.$c_Lpresto_CredentialsView$$anon$67().afc(a), a);
});
$p.ae = (function(a) {
  return this.ad6(a);
});
var $d_Lpresto_CredentialsView$$anon$62 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$62, "presto.CredentialsView$$anon$62", ({
  Gb: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$62 as $d_Lpresto_CredentialsView$$anon$62 };
//# sourceMappingURL=presto.-Credentials-View$$anon$62.js.map
